query referenciaGcpjAndamentoSelect($where: ReferenciaGcpjAndamentoModelFilterInput) {
    data: referenciasGcpjsAndamentos(
        where: $where 
        order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}